import { render, staticRenderFns } from "./ConfigIntegrationSubmissionSpecifications.vue?vue&type=template&id=54689bb5&scoped=true&"
import script from "./ConfigIntegrationSubmissionSpecifications.vue?vue&type=script&lang=js&"
export * from "./ConfigIntegrationSubmissionSpecifications.vue?vue&type=script&lang=js&"
import style0 from "./ConfigIntegrationSubmissionSpecifications.vue?vue&type=style&index=0&id=54689bb5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54689bb5",
  null
  
)

export default component.exports